<template>
  <div>
    <h-loading v-if="loading" />
    <div v-else>
      <h6 class="text-uppercase grey--text">
        {{ $t('movement.label.createdAt') }}
      </h6>
      <p class="body-2">
        {{ date }}
      </p>

      <h6 class="text-uppercase grey--text">
        {{ $t('movement.label.description') }}
      </h6>
      <p class="body-2">
        {{ description }}
      </p>

      <h6 class="text-uppercase grey--text">
        {{ $t('movement.label.rechargeNote') }}
      </h6>
      <p class="body-2">
        {{ rechargeNote }}
      </p>

      <h6 class="text-uppercase grey--text">
        {{ $t('movement.label.total') }}
      </h6>
      <p :class="`${moneyColor} body-2`">
        {{ total }}
      </p>

      <div v-if="appointment">
        <h6 class="text-uppercase grey--text mb-1">
          {{ $t('movement.label.appointment') }}
        </h6>
        <v-btn @click="toAppointmentDetails()" elevation="0" color="primary" outlined small>
          <span class="body-2">
            {{ $t('movement.label.showAppointment') }} {{ appointmentCode }}
          </span>
          <v-icon x-small right>
            mdi-open-in-new
          </v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { catalogDate, catalogMonetary } from '@/util/catalog'

export default {
  name: 'MovementServiceSummary',

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters(['isLoading', 'movement']),

    date() {
      return this.movement.created_at ? catalogDate(this.movement.created_at) : '---'
    },

    description() {
      return this.movement.description ?? '---'
    },

    rechargeNote() {
      return this.movement.recharge_comment ?? '---'
    },

    appointment() {
      return this.movement.appointment
    },

    appointmentCode() {
      if (!this.appointment) return
      return this.appointment.code
    },

    total() {
      return this.movement.total ? catalogMonetary(this.movement.total) : '---'
    },

    totalRaw() {
      return this.movement.total
    },

    moneyColor() {
      if (!this.totalRaw) return 'grey--text text--lighten-1'
      return this.totalRaw > 0 ? 'green--text text--lighten-1' : 'red--text text--lighten-1'
    },

    isAdminOrPartner() {
      const roles = localStorage.getItem('access_roles')
      const userRoles = roles?.split(',')
      return userRoles?.includes('ROLE_ADMIN') || userRoles?.includes('ROLE_PARTNER')
    },

    appointmentRoutePath() {
      return this.isAdminOrPartner ? '../admin-appointment/' : '../appointments/'
    },
  },

  methods: {
    toAppointmentDetails() {
      window.open(`${this.appointmentRoutePath}${this.appointment.id}`, '_blank')
    },
  },
}
</script>
